// extracted by mini-css-extract-plugin
export default {"callHistorySection":"CallHistory_callHistorySection__bjlgz"};